module.exports = __webpack_public_path__ + "static/media/t1-img1.e0dfa009.png";